import logo from "./spectsgenieLogo.png";
import sglogo from "./sglogo.png";
import bannerImgOne from "./banner/bannerImgOne.jpeg";
import bannerImgTwo from "./banner/bannerImgTwo.jpeg";
import bannerImgThree from "./banner/bannerImgThree.jpeg";

// ============== Products Start here ====================
// New Arrivals
import newArrOne from "./products/newArrival/newArrOne.webp";
import newArrTwo from "./products/newArrival/newArrTwo.webp";
import newArrThree from "./products/newArrival/newArrThree.webp";
import newArrFour from "./products/newArrival/newArrFour.webp";


// Special Offers
import spfOne from "./products/specialOffer/spfOne.webp";
import spfTwo from "./products/specialOffer/spfTwo.webp";
import spfThree from "./products/specialOffer/spfThree.webp";
import spfFour from "./products/specialOffer/spfFour.webp";

// Year Product
// ============== Products End here ======================

export {
  logo,
  sglogo,
  bannerImgOne,
  bannerImgTwo,
  bannerImgThree,

  // ===================== Products start here ============
  // New Arrivals
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,



  // Sprcial Offers
  spfOne,
  spfTwo,
  spfThree,
  spfFour,

  // Year Product
  // ===================== Products End here ==============

};
